import { createSelector } from '@reduxjs/toolkit';

import { LocaleState } from 'verify/redux/reducers/locale';

interface StateWithLocale {
  locale: LocaleState;
}

/*
 * We use LatLngLiteral because `google` is an async defer script-src and it's possible that it
 * hasn't loaded by the time the app is booted.
 *
 * Safe access on `locale` so components using this can render in Dashboard safely
 * e.g. in theme editor preview
 */
export const latLngSelector = createSelector(
  (state: StateWithLocale) => state.locale?.localeInfo,
  (localeInfo) =>
    localeInfo?.latitude && localeInfo?.longitude
      ? {
          lat: localeInfo.latitude,
          lng: localeInfo.longitude,
        }
      : undefined,
);
